import { FuelButton, FuelIcon, FuelTypography } from '@frete.com/fuel-react'
import styled from 'styled-components'

const hexadecimalOpacity = 'CC'

export const Background = styled.div`
  background-color: ${({ theme }) => theme.color.background.neutral.inverted + hexadecimalOpacity};
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    align-items: end;
  }
`

export const Container = styled.div`
  width: 360px;
  background: ${({ theme }) => theme.color.background.neutral.default};
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km6};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
`

export const Title = styled(FuelTypography).attrs({ size: 'heading-sm', weight: 'bold' })`
  margin-bottom: ${({ theme }) => theme.spacing.km3};
`

export const Content = styled(FuelTypography).attrs({ size: 'body-md', weight: 'medium', color: 'neutral-default' })``

export const ConfirmButton = styled(FuelButton).attrs({
  size: 'large',
})``

export const CloseIcon = styled(FuelIcon).attrs({ name: 'close', size: 'small' })`
  cursor: pointer;
`

export const CancelButton = styled(FuelButton).attrs({
  size: 'large',
  variant: 'tertiary',
})`
  margin-right: ${({ theme }) => theme.spacing.km2};
`

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacing.km6};
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
`
